import { jsx as _jsx } from "react/jsx-runtime";
import { Field } from '@base-ui/react/field';
import { cn } from '../../../utils/utils';
// Label + control + help/error stack. Base UI wires `htmlFor`, `aria-describedby`
// and `aria-invalid` between these and any Base.Input / Textarea / Combobox inside,
// so the app only writes the copy.
export const FieldRoot = ({ className, ...props }) => {
    return (_jsx(Field.Root, { ...props, className: cn('flex flex-col gap-1.5 font-roobert', className) }));
};
export const FieldLabel = ({ className, ...props }) => {
    return (_jsx(Field.Label, { ...props, className: cn('text-sm font-medium leading-5 text-neutral-900', className) }));
};
export const FieldDescription = ({ className, ...props }) => {
    return (_jsx(Field.Description, { ...props, className: cn('text-xs leading-4 text-neutral-500', className) }));
};
export const FieldError = ({ className, ...props }) => {
    return (_jsx(Field.Error, { ...props, className: cn('text-xs leading-4 text-red-500', className) }));
};
